// extracted by mini-css-extract-plugin
export default {"featuredSupplierOptionsAdApplications":"featured-supplier-ad-form_featuredSupplierOptionsAdApplications__xG1HV"};